import { CRITICAL, WARNING } from '@/features/batteryOverview/utils/BatteryDataUtils';

type barChartTypes = {
    value?: number;
    status?: string;
    valueClassName?: string;
};

const BarChart = ({ value, status, valueClassName = '' }: barChartTypes) => {
    let statusClassName: string = ' progress-bar';
    switch (status) {
        case WARNING:
            statusClassName = `${statusClassName}-warning`;
            break;
        case CRITICAL:
            statusClassName = `${statusClassName}-danger`;
            break;
        default:
            statusClassName = '';
    }

    return (
        <div className="width-100pct display-flex align-items-center">
            <div className="progress margin-0 flex-1-0">
                <div
                    data-testid={'progress-bar'}
                    className={`progress-bar${statusClassName}`}
                    style={{ width: `${value}%` }}
                />
            </div>
            <div className={`margin-left-10 ${valueClassName}`}>{`${value}%`}</div>
        </div>
    );
};

export default BarChart;
